import React from 'react';

import twMerge from 'utilities/src/twMerge';

import Image from '../../../Image';

import ButtonLink from '../../../ButtonLink';

/**
 * Widget Quote Props
 */

type WidgetQuoteProps = {
  quote: string;
  author: {
    name: string;
    company: string;
    image: string;
  };
  link?: {
    label: string;
    href: string;
  };
  iconClassName?: string;
  textClassName?: string;
};

/**
 * Widget Quote Component
 */

export default function WidgetQuote({ quote, author, link, iconClassName, textClassName }: WidgetQuoteProps) {
  return (
    <div className="relative flex flex-col pt-4">
      <span
        className={twMerge(
          'text-site-primary-600 mdL:block absolute left-0 top-0 hidden -translate-x-7 -translate-y-10 text-6xl font-bold md:text-8xl',
          iconClassName,
        )}
      >
        “
      </span>

      <p
        className={twMerge(
          "site-paragraph-xl text-site-neutrals-900 after:mdL:hidden before:mdL:hidden px-4 font-normal before:content-['”'] after:content-['“']",
          textClassName,
        )}
      >
        {quote}
      </p>

      <div
        className={twMerge('bg-site-primary-25 mt-4 flex items-center gap-2 px-3 py-4', !link && 'rounded-b-lg')}
      >
        <div className="bg-site-neutrals-0 relative flex h-14 w-14 items-center justify-center rounded-full">
          <Image src={author.image} alt={author.name} width={24} height={32} />
        </div>

        <div className="flex flex-col">
          <span className="site-paragraph-m text-site-neutrals-900 font-normal">{author.name}</span>
          <span className="site-paragraph-xs text-site-neutrals-600 font-normal">{author.company}</span>
        </div>
      </div>

      {link && (
        <div className="bg-site-neutrals-900 flex items-center justify-center rounded-b-lg">
          <ButtonLink href={link.href} size="Small" variant="Primary" variantColor="Black" classes="w-full">
            {link.label}
          </ButtonLink>
        </div>
      )}
    </div>
  );
}
